import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    close: 'self-center',
    container: 'p-3 b b-grey-70 rounded-xs bg-white flex gap-2 shadow-xs items-center relative',
    icon: 'self-center',
    message: 'body-4 c-brand-1'
  },
  closeVariant: 'label',
  iconSize: 'md'
} satisfies VfConfig['notification']
